import { useState } from "react";
import {
  Globe,
  CaretRight,
  CheckCircle,
} from "@phosphor-icons/react";

export function RegionCard({ region }) {
  const [expanded, setExpanded] = useState(false);
  
  return (
    <div className="border border-slate-200 rounded-sm p-4 bg-white card-hover">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between"
        data-testid={`region-${region.region.toLowerCase()}`}
      >
        <div className="flex items-center gap-2">
          <Globe size={18} className="text-blue-700" />
          <span className="font-bold text-slate-900">{region.region}</span>
        </div>
        <CaretRight size={16} className={`text-slate-400 transition-transform ${expanded ? "rotate-90" : ""}`} />
      </button>
      
      {expanded && (
        <div className="mt-4 pt-4 border-t border-slate-100 animate-fade-in">
          <div className="space-y-3 text-sm font-body">
            <div>
              <p className="text-slate-500 text-xs mb-1">Setup Time</p>
              <p className="text-slate-900">{region.estimated_setup_time}</p>
            </div>
            <div>
              <p className="text-slate-500 text-xs mb-1">Steps</p>
              <ol className="space-y-1">
                {region.steps.map((step, i) => (
                  <li key={`step-${step.slice(0, 20)}`} className="flex items-start gap-2 text-slate-600">
                    <span className="text-blue-700 font-bold">{i + 1}.</span>
                    {step}
                  </li>
                ))}
              </ol>
            </div>
            <div>
              <p className="text-slate-500 text-xs mb-1">Requirements</p>
              <ul className="space-y-1">
                {region.requirements.map((req) => (
                  <li key={`req-${req.slice(0, 20)}`} className="flex items-center gap-2 text-slate-600">
                    <CheckCircle size={14} className="text-emerald-600" />
                    {req}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-slate-500 text-xs mb-1">Local Considerations</p>
              <p className="text-slate-600">{region.local_considerations}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
